import { render, staticRenderFns } from "./changeOrg.vue?vue&type=template&id=b16ae084&scoped=true"
import script from "./changeOrg.vue?vue&type=script&lang=js"
export * from "./changeOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16ae084",
  null
  
)

export default component.exports